module.exports = __webpack_public_path__ + "img/entregadoParcial.6ea61a0f.gif";